import Select from 'shared/components/Select'
import Button from '@components/Button'
import { getCreditCardNumberPreview } from 'shared/utils'

import { creditCardsSelector } from '../selectors'

const CreditCardList = ({ cards, selectedCard, onCardSelected, disabled }) => {
    const onChangeHandler = value => {
        onCardSelected(value.id)
    }
    return (
        <div className="booking__select">
            <Select
                options={cards}
                value={selectedCard}
                onChange={onChangeHandler}
                isDisabled={disabled}
                getOptionValue={option => option.id}
                getOptionLabel={({ nickName, cardLast4, expDate }) =>
                    getCreditCardNumberPreview({ nickName, cardLast4, expDate })
                }
            />
            {!disabled && (
                <Button
                    className="booking__select__button"
                    size="small"
                    btnStyle="link"
                    iconLeft="plus-round"
                    href="dashboard/credit-cards">
                    <T>dashboard.label.add.credit.card</T>
                </Button>
            )}
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    cards: creditCardsSelector,
})

export default connect(mapStateToProps)(CreditCardList)
